
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069.005-1761.245a.922.922 0 00.674-.259.909.909 0 00.264-.679v-11.757l-.107-2.91-.574.253 3.174 3.516 2.109 2.07a.877.877 0 00.3.2.977.977 0 00.366.068.869.869 0 00.64-.259.881.881 0 00.259-.649.948.948 0 00-.293-.674l-6.1-6.113a.981.981 0 00-.327-.234.938.938 0 00-.376-.078.915.915 0 00-.366.078.981.981 0 00-.327.234l-6.1 6.113a.948.948 0 00-.293.674.89.89 0 00.254.649.865.865 0 00.645.259.977.977 0 00.366-.068.877.877 0 00.3-.2l2.1-2.07 3.149-3.516-.557-.254-.107 2.91v11.758a.918.918 0 00.259.679.905.905 0 00.668.259z"}})])])
          )
        }
      }
    